export default function TextAreaLabel({labelName,inputName,defaultValue,onChangeFn,maxLen}){
  return(
    <>
      <label>{labelName}</label>
      <textarea defaultValue={defaultValue} name={inputName} onChange={onChangeFn} maxLength={maxLen}/>
    </>
  )
}